document.addEventListener("DOMContentLoaded", () => {
  const checkbox = document.querySelector("#use_shipping");
  const deliveryAddressForm = document.querySelector(".billing-address-form");
  const deliveryRadio = document.querySelector(".js-radioTabs__trigger");

  if (!checkbox || !deliveryAddressForm || !deliveryRadio) return;

  const toggleFormVisibility = () => {
    if (checkbox.checked) {
      deliveryAddressForm.classList.remove(
        "billing-address-form__show-billing-address-form"
      );
    } else {
      deliveryAddressForm.classList.add(
        "billing-address-form__show-billing-address-form"
      );
    }
  };

  checkbox.addEventListener("change", toggleFormVisibility);

  toggleFormVisibility();

  const storeRadio = document.querySelector('input[id="store"]');
  if (storeRadio) {
    storeRadio.addEventListener("change", (event) => {
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event("change"));
    });
  }
});
